/** hr 系统路由 **/
import Layout from "@/views/layout/Layout";
const hrManRouter = {
  path: "/hrMan",
  component: Layout,
  redirect: "/hrMan/flowChart/list",
  name: "hrMan",
  meta: {
    title: "人力资源",
    icon: "user",
    roles: ["renliziyuan"]
  },
  children: [
    // 1 组织规划
    {
      path: "orgPlan",
      component: () => import("@/views/hrMan/orgPlan/index"),
      meta: {
        title: "组织规划",
        roles: ["zuzhiguihua"]
      },
      alwaysShow: true,
      children: [
        // 1 组织架构
        {
          path: "departmentMan/:label",
          component: () => import("@/views/hrMan/orgPlan/departmentMan"),
          name: "组织架构",
          meta: {
            title: "组织架构",
            roles: ["zuzhijiagou"]
          }
        },
        // 2 岗位管理
        {
          path: "postMan",
          component: () => import("@/views/hrMan/orgPlan/postMan/index"),
          name: "岗位管理",
          meta: {
            title: "岗位管理",
            roles: ["gangweiguanli"],
            keepAlive: true
          }
        },

        // 岗位 审批代理人
        {
          path: "postAgent",
          component: () => import("@/views/hrMan/orgPlan/postAgent"),
          name: "代理人维护",
          meta: {
            title: "代理人维护",
            roles: ["dailirenweihu"]
          }
        },

        // 3 职等职级管理
        {
          path: "rankLevelMan",
          component: () => import("@/views/hrMan/orgPlan/rankLevelMan/index"),
          name: "职等职级管理",
          meta: {
            title: "职等职级管理",
            roles: [
              "zhidengzhiji",
              "zhidengfenleiguanli",
              "zhidengguanli",
              "zhijiguanli"
            ]
          }
          // children: [
          //   // 1 组织架构
          //   {
          //     path: 'rankTypeMan',
          //     component: () => import('@/views/hrMan/orgPlan/rankLevelMan/rankTypeMan'),
          //     name: '职等分类管理',
          //     // hidden: true,
          //     meta: {
          //       title: '职等分类管理',
          //       roles: ['zhidengfenleiguanli']
          //     }
          //   },
          //   {
          //     path: 'rankZhideng/:id',
          //     component: () => import('@/views/hrMan/orgPlan/rankLevelMan/rankZhideng'),
          //     name: '职等管理',
          //     // hidden: true,
          //     meta: {
          //       title: '职等管理',
          //       roles: ['zhidengguanli']
          //     }
          //   },
          //   {
          //     // path: 'rankZhiji',
          //     path: 'rankZhiji/:zdflId/:zdId',
          //     component: () => import('@/views/hrMan/orgPlan/rankLevelMan/rankZhiji'),
          //     name: '职级管理',
          //     // hidden: true,
          //     meta: {
          //       title: '职级管理',
          //       roles: ['zhijiguanli']
          //     }
          //   }
          // ]
        },
        // 4 组管理
        // {
        //   path: 'groupMan',
        //   component: () => import('@/views/hrMan/orgPlan/groupMan'),
        // 	name: '组管理',
        //   meta: {
        //     title: '组管理',
        //     roles: ['admin']
        //   }
        // },
        // 5 核算部门管理
        {
          path: "hsDepartmentMan",
          component: () => import("@/views/hrMan/orgPlan/hsDepartmentMan"),
          name: "核算部门管理",
          meta: {
            title: "核算部门管理",
            roles: ["hesuanbumenguanli"]
          }
        }
      ]
    },
    // 3 考勤管理
    {
      path: "attendanceMan",
      component: () => import("@/views/hrMan/attendanceMan/index"),
      meta: {
        title: "考勤管理",
        roles: ["kaoqinguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "ruleSet",
          component: () => import("@/views/hrMan/attendanceMan/ruleSet/index"),
          name: "考勤规则设置",
          meta: {
            title: "考勤规则设置",
            // roles: ['guizeshezhi', 'quekaguize', 'kuanggongguize', 'chidaozaotuiguize']
            roles: ["guizeshezhi"]
          }
        },
        {
          path: "ruleSetDuty",
          component: () =>
            import("@/views/hrMan/attendanceMan/ruleSetDuty/index"),
          name: "值班规则设置",
          meta: {
            title: "值班规则设置",
            // roles: ['guizeshezhi', 'quekaguize', 'kuanggongguize', 'chidaozaotuiguize']
            roles: ["zhibanguizeshezhi"]
          }
        },

        // 1 考勤设置 - 节假日设置，考勤组分类，考勤组定义，考勤组绑定
        {
          path: "attendanceSet",
          component: () =>
            import("@/views/hrMan/attendanceMan/attendanceSet/index"),
          name: "考勤设置",
          meta: {
            title: "考勤设置",
            roles: [
              "kaoqinshezhi",
              "jiejiarishezhi",
              "kaoqinzufenlei",
              "kaoqinzuguanli"
            ]
          }
        },

        // 2 考勤设置监管
        {
          path: "attendanceSetJg",
          component: () =>
            import("@/views/hrMan/attendanceMan/attendanceSetJg/index"),
          name: "考勤设置监管",
          meta: {
            title: "考勤设置监管",
            roles: [
              "kaoqinshezhijianguan",
              "bumenkaoqinshezhijianguan",
              "gangweikaoqinshezhijianguan",
              "bukaoqinjianguan"
            ]
          }
        },

        // 3 考勤监管 - 考勤抽查，违规抽查，黑名单管理，考勤明细 , 打卡统计，打卡记录
        {
          path: "attendanceSupervise",
          component: () =>
            import("@/views/hrMan/attendanceMan/attendanceSupervise/index"),
          name: "考勤监管",
          meta: {
            title: "考勤监管",
            roles: [
              "kaoqinjianguan",
              "kaoqinchoucha",
              "weiguidaka",
              "heimingdan",
              "kaoqinmingxi",
              "dakatongji",
              "dakajilu"
            ]
          }
        },

        // 5 排班管理
        {
          path: "paibanMan",
          component: () =>
            import("@/views/hrMan/attendanceMan/paibanMan/paiban"),
          name: "排班管理",
          meta: {
            title: "排班管理",
            roles: ["paibanguanli"]
          }
        },

        // 5.1 人资排班
        {
          path: "paibanMan/humanResources",
          component: () =>
            import("@/views/hrMan/attendanceMan/paibanMan/paiban"),
          name: "人资排班",
          meta: {
            title: "人资排班",
            roles: ["renzipaiban"]
          }
        },
        // 5.2 主管排班
        {
          path: "paibanMan/executiveDirector",
          component: () =>
            import("@/views/hrMan/attendanceMan/paibanMan/paiban"),
          name: "主管排班",
          meta: {
            title: "主管排班",
            roles: ["zhuguanpaiban"]
          }
        },
        // 5.3 法休申报
        {
          path: "StatutoryRestMan",
          component: () =>
            import(
              "@/views/hrMan/attendanceMan/statutoryRest/StatutoryRestMan"
            ),
          name: "法休申报",
          meta: {
            title: "法休申报",
            roles: ["faxiushenbao_web"]
          }
        },
        // 5.4 法休审核
        {
          path: "StatutoryRestAuth",
          component: () =>
            import(
              "@/views/hrMan/attendanceMan/statutoryRest/StatutoryRestAuth"
            ),

          name: "法休审核",
          meta: {
            title: "法休审核",
            roles: ["faxiushenhe_web"]
          }
        },

        // 6 人脸录入审核  faceInputExamine
        {
          path: "faceInputExamine",
          component: () =>
            import("@/views/hrMan/attendanceMan/faceInputExamine"),
          name: "人脸录入审核",
          meta: {
            title: "人脸录入审核",
            roles: ["renlianlurushenhe"]
          }
        },

        // 7 人脸录入监管
        {
          path: "faceInputSupervise",
          component: () =>
            import("@/views/hrMan/attendanceMan/faceInputSupervise"),
          name: "人脸录入监管",
          meta: {
            title: "人脸录入监管",
            roles: ["renlianlurujianguan"]
          }
        },

        {
          path: "mAReportDesc/:id/:name/:date",
          hidden: true,
          component: () =>
            import(
              "@/views/hrMan/attendanceMan/attendanceSupervise/mAReportDesc"
            ),
          name: "考勤明细",
          meta: {
            title: "考勤明细",
            roles: ["kaoqinmingxi"]
          }
        }
      ]
    },
    // 4 薪酬管理
    {
      path: "payMan",
      component: () => import("@/views/hrMan/payMan/index"),
      meta: {
        title: "薪酬管理",
        roles: ["xinchouguanli"]
      },
      alwaysShow: true,
      children: [
        // 1 薪酬审核 - 薪酬审核，薪酬审核配置
        // {
        //   path: 'salaryAuth',
        //   component: () => import('@/views/hrMan/payMan/salaryAuth/index'),
        // 	name: '薪酬审核',
        //   meta: {
        //     title: '薪酬审核',
        //     roles: ['xinchoushenhe']
        //   }
        // },

        // 2 薪酬维护 - 薪酬结构维护，社保导入，个税导入，绩效导入，工资表划分管理，替岗工资计算维护
        {
          path: "payMaintain",
          component: () => import("@/views/hrMan/payMan/payMaintain/index"),
          name: "薪酬维护",
          meta: {
            title: "薪酬维护",
            roles: ["xinchouweihu"]
          }
        },
        // 3 薪酬核算
        {
          path: "salaryAccounting",
          component: () => import("@/views/hrMan/payMan/salaryAccounting"),
          name: "薪酬核算",
          meta: {
            title: "薪酬核算",
            roles: ["xinchouhesuan"]
          }
        },
       
        // --工资表审批功能
        {
          path: "manualWageImport",
          component: () =>
            import("@/views/hrMan/payMan/manualWageImport/index"),
          name: "手工工资导入",
          meta: {
            title: "手工工资导入",
            roles: ["shougonggongzidaoru"]
          }
        },
        {
          path: "payrollBudgetUse",
          component: () =>
            import("@/views/hrMan/payMan/payrollBudgetUse/index"),
          name: "工资预算使用管理",
          meta: {
            title: "工资预算使用管理",
            roles: ["gongziyusuanshiyongguanli"]
          }
        },
        {
          path: "overAgeImport",
          component: () =>
            import("@/views/hrMan/payMan/overAgeImport/index"),
          name: "超龄扣款导入",
          meta: {
            title: "超龄扣款导入",
            roles: ["chaolingkoukuandaoru"]
          }
        },
        // 补助批量导入
        {
          path: "subsidyBatchImport",
          component: () =>
            import("@/views/hrMan/payMan/subsidyBatchImport/index"),
          name: "补助批量导入",
          meta: {
            title: "补助批量导入",
            roles: ["piliangbuzhudaoru"]
          }
        },
        {
          path: "preliminaryWageReview",
          component: () =>
            import("@/views/hrMan/payMan/preliminaryWageReview/index"),
          name: "工资初审",
          meta: {
            title: "工资初审",
            roles: ["gongzichushen"]
          }
        },
        {
          path: "wageReview",
          component: () => import("@/views/hrMan/payMan/wageReview/index"),
          name: "工资复审",
          meta: {
            title: "工资复审",
            roles: ["gongzifushen"]
          }
        },
        {
          path: "wageIssueExport",
          component: () => import("@/views/hrMan/payMan/wageIssueExport/index"),
          name: "发放导出",
          meta: {
            title: "发放导出",
            roles: ["fafangdaochu"]
          }
        },
         // 工资统计表
        {
          path: "wageStatistics",
          component: () => import("@/views/hrMan/payMan/wageStatistics/index"),
          name: "工资统计表",
          meta: {
            title: "工资统计表",
            roles: ["gongzitongjibiao"]
          }
        },
        //7薪酬
        {
          path: "salaryReview",
          component: () => import("@/views/hrMan/payMan/salaryReview/index"),
          meta: {
            title: "薪酬审核",
            roles: ["xinchoushenhe"]
          },
          alwaysShow: true,
          children: [
            {
              path: "salarySummaryAccounting",
              component: () =>
                import(
                  "@/views/hrMan/payMan/salaryReview/salarySummaryAccounting"
                ),
              name: "工资汇总表核算",
              meta: {
                title: "工资汇总表核算",
                roles: ["gongzihuizongbiaohesuan"]
              }
            },
            {
              path: "levelOneAudit",
              component: () =>
                import("@/views/hrMan/payMan/salaryReview/levelOneAudit"),
              name: "工资汇总表一级审核",
              meta: {
                title: "工资汇总表一级审核",
                roles: ["gongzihuizongbiaoyijishenhe"]
              }
            },
            {
              path: "levelTwoAudit",
              component: () =>
                import("@/views/hrMan/payMan/salaryReview/levelTwoAudit"),
              name: "工资汇总表二级审核",
              meta: {
                title: "工资汇总表二级审核",
                roles: ["gongzihuizongbiaoerjishenhe"]
              }
            },
            {
              path: "levelThreeAudit",
              component: () =>
                import("@/views/hrMan/payMan/salaryReview/levelThreeAudit"),
              name: "工资汇总表三级审核",
              meta: {
                title: "工资汇总表三级审核",
                roles: ["gongzibiaosanjishenhe"]
              }
            },
            {
              path: "levelFourAudit",
              component: () =>
                import("@/views/hrMan/payMan/salaryReview/levelFourAudit"),
              
              name: "工资发放",
              meta: {
                title: "工资发放",
                roles: ["gongzihuizongbiaosanjishenhe"]
              }
            }
          ]
        },
        // {
        //   path: "wagePayment",
        //   component: () => import("@/views/hrMan/payMan/wagePayment"),
        //   name: "工资发放",
        //   meta: {
        //     title: "工资发放",
        //     roles: ["gongzifafang"]
        //   }
        // },
        // {
        //   path: "wageSupervisionExamination",
        //   component: () => import("@/views/hrMan/payMan/wageSupervisionExamination"),
        //   name: "工资表监审",
        //   meta: {
        //     title: "工资表监审",
        //     roles: ["gongzibiaojianshen"]
        //   }
        // },
        // {
        //   path: "wageInquiry",
        //   component: () => import("@/views/hrMan/payMan/wageInquiry"),
        //   name: "工资表查询(会计入账)",
        //   meta: {
        //     title: "工资表查询(会计入账)",
        //     roles: ["gongzibiaochaxunkuaijiruzhang"]
        //   }
        // },
        // {
        //   path: "humanResourceInquiry",
        //   component: () => import("@/views/hrMan/payMan/humanResourceInquiry"),
        //   name: "发放失败查询(人资)",
        //   meta: {
        //     title: "发放失败查询(人资)",
        //     roles: ["renzifafangshibaichaxun"]
        //   }
        // }
        // {
        //   path: "financeInquiry",
        //   component: () => import("@/views/hrMan/payMan/financeInquiry"),
        //   name: "财务发放失败查询",
        //   meta: {
        //     title: "财务发放失败查询",
        //     roles: ["caiwufafangshibaichaxun"]
        //   }
        // },
        // 3 薪酬发放
        // {
        //   path: 'salaryGrant',
        //   component: () => import('@/views/hrMan/payMan/salaryGrant'),
        // 	name: '薪酬发放',
        //   meta: {
        //     title: '薪酬发放',
        //     roles: ['xinchouhesuan']
        //   }
        // },

        // 4 薪酬查询
        // {
        //   path: 'salarySearch',
        //   component: () => import('@/views/hrMan/payMan/salarySearch'),
        // 	name: '薪酬查询',
        //   meta: {
        //     title: '薪酬查询',
        //     roles: ['xinchouchaxun']
        //   }
        // },
      ]
    },

    // 2 员工管理
    {
      path: "staffMan",
      component: () => import("@/views/hrMan/staffMan/index"),
      meta: {
        title: "员工管理",
        roles: ["yuangongguanli"]
      },
      alwaysShow: true,
      children: [
        // 1 档案管理(运营)（原 员工档案）
        {
          path: "staffList/operate",
          component: () => import("@/views/hrMan/staffMan/staffList"),
          name: "档案管理(运营)",
          meta: {
            title: "档案管理(运营)",
            roles: ["danganguanliyunying"],
            keepAlive: true
          }
        },
        // 1 档案管理(集团)
        {
          path: "staffList/group",
          component: () => import("@/views/hrMan/staffMan/staffList"),
          name: "档案管理(集团)",
          meta: {
            title: "档案管理(集团)",
            roles: ["danganguanlijituan"],
            keepAlive: true
          }
        },

        // 2 入职黑名单
        {
          path: "entryBlacklist",
          component: () => import("@/views/hrMan/staffMan/entryBlacklist"),
          name: "入职黑名单",
          meta: {
            title: "入职黑名单",
            roles: ["ruzhiheimingdan"]
          }
        },
        // 2 我的雇主保险单
        {
          path: "employerGuaranteeSlip",
          component: () =>
            import("@/views/hrMan/staffMan/employerGuaranteeSlip"),
          name: "我的雇主保险单",
          meta: {
            title: "我的雇主保险单",
            roles: ["wodeguzhubaoxiandan"]
          }
        },
        // 2 雇主保险单管理
        {
          path: "policyOfInsuranceAdministrator",
          component: () =>
            import("@/views/hrMan/staffMan/policyOfInsuranceAdministrator"),
          name: "雇主保险单管理",
          meta: {
            title: "雇主保险单管理",
            roles: ["guzhubaoxiandanguanli"]
          }
        },
        // 2 回退单据
        {
          path: "returnDdocuments",
          component: () =>
            import("@/views/hrMan/staffMan/returnDdocuments"),
          name: "回退单据",
          meta: {
            title: "回退单据",
            roles: ["huituidanju"]
          }
        }
      ]
    },

    // 5 社保查询  , 'shebaoguanxiguanli', 'shebaodaoru', 'shebaochaxun', 'shebaotongji'
    {
      path: "sbQuery",
      component: () => import("@/views/hrMan/sbQuery/index"),
      name: "保险管理",
      meta: {
        title: "保险管理",
        roles: ["shebaoguanli"]
      }
    },
    // 公积金管理
    {
      path: "accumulationFundMan",
      component: () => import("@/views/hrMan/accumulationFundMan/index"),
      name: "公积金管理",
      meta: {
        title: "公积金管理",
        roles: ["gongjijinguanli"]
      }
    },

    // 单据查询
    {
      path: "orderQuery",
      component: () => import("@/views/hrMan/orderQuery"),
      name: "单据查询",
      meta: {
        title: "单据查询",
        roles: ["danjuguanli"]
      }
    },

    // {
    //   path: "orderQueryOld",
    //   component: () => import("@/views/hrMan/orderQueryOld"),
    //   name: "单据查询旧",
    //   meta: {
    //     title: "单据查询旧",
    //     roles: ["danjuguanli"]
    //   }
    // },

    // 报表管理
    {
      path: "reportForm",
      component: () => import("@/views/hrMan/reportForm/index"),
      name: "报表管理",
      meta: {
        title: "报表管理",
        roles: ["baobiaoguanli"]
      },
      alwaysShow: true,
      children: [
        // 2 员工花名册
        {
          path: "employeeRoster",
          component: () => import("@/views/hrMan/reportForm/employeeRoster"),
          name: "员工花名册",
          meta: {
            title: "员工花名册",
            roles: ["yuangonghuamingce"]
          }
        },
        // 3 兼岗报表
        {
          path: "partTimeReport",
          component: () => import("@/views/hrMan/reportForm/partTimeReport"),
          name: "兼岗报表",
          meta: {
            title: "兼岗报表",
            roles: ["jiangangbaobiao"]
          }
        },
        // 岗位信息查询
        {
          path: "postInfo",
          component: () => import("@/views/hrMan/orgPlan/postInfo"),
          name: "岗位信息查询",
          meta: {
            title: "岗位信息查询",
            roles: ["gangweixinxichaxun"]
          }
        },

        // 4 考勤月报 - 考勤月报汇总，考勤月报明细
        {
          path: "mAReportByDepart",
          component: () =>
            import("@/views/hrMan/attendanceMan/mAReportByDepart"),
          // component: () => import('@/views/hrMan/attendanceMan/attendanceMonthly/index'),
          name: "考勤月报",
          meta: {
            title: "考勤月报",
            roles: ["kaoqinyuebao"]
          }
        },

        {
          path: "postDetail",
          component: () => import("@/views/hrMan/reportForm/postDetail"),
          name: "岗位明细表",
          meta: {
            title: "岗位明细表",
            roles: ["gangweimingxibiao"]
          }
        },
        {
          path: "distanceReport",
          component: () => import("@/views/hrMan/reportForm/distanceReport"),
          name: "员工项目部距离报表",
          meta: {
            title: "员工项目部距离报表",
            roles: ["yuangongxiangmubujulibaobiao"]
          }
        },
        {
          path: "partTimeDaysReport",
          component: () => import("@/views/hrMan/reportForm/partTimeDaysReport"),
          name: "项目部兼岗天数报表",
          meta: {
            title: "项目部兼岗天数报表",
            roles: ["xiangmubujiangangtianshubaobiao"]
          }
        },
        {
          path: "enptyJobInfoReport",
          component: () => import("@/views/hrMan/reportForm/enptyJobInfoReport"),
          name: "空岗信息统计表",
          meta: {
            title: "空岗信息统计表",
            roles: ["konggangxinxitongjibiao"]
          }
        },
        {
          path: "enptyJobDataAnalysisReport",
          component: () => import("@/views/hrMan/reportForm/enptyJobDataAnalysisReport"),
          name: "空岗数据分析表",
          meta: {
            title: "空岗数据分析表",
            roles: ["konggangxinxifenxibiao"]
          }
        },
        {
          path: "employeeCertificateReport",
          component: () => import("@/views/hrMan/reportForm/employeeCertificateReport"),
          name: "员工证书",
          meta: {
            title: "员工证书",
            roles: ["hryuangongzhengshu"]
          }
        },
      ]
    },
    // 新 婚丧假补办
    {
      path: "marriageAndFuneralLeaveReissue",
      component: () =>
        import("@/views/processMan/marriageAndFuneralLeaveReissue/index"),
      name: "婚丧假补办",
      meta: {
        title: "婚丧假补办",
        roles: ["hunsangjiabuban"]
      },
      hidden: true
    },
    // 新 婚丧假复核
    {
      path: "marriageAndFuneralLeaveCheck",
      component: () =>
        import("@/views/processMan/marriageAndFuneralLeaveCheck"),
      name: "婚丧假复核",
      meta: {
        title: "婚丧假复核",
        roles: ["hunsangjiafuhe"]
      }
    }

    // 6 单据管理

    // {
    //   path: 'billDesc/:typeId',
    //   component: () => import('@/views/hrMan/billMan/billDesc'),
    //   name: '单据详情',
    //   hidden: true,
    //   meta: {
    //     title: '单据详情',
    //     roles: ['admin']
    //   },
    //   // children: []
    // },
  ]
};

export default hrManRouter;
